import { render, staticRenderFns } from "./resetStaffPwd.vue?vue&type=template&id=c4e54f3c"
import script from "./resetStaffPwd.vue?vue&type=script&lang=js"
export * from "./resetStaffPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports